import { Component } from '@angular/core';

@Component({
  selector: 'app-insurance-claim-create',
  templateUrl: './insurance-claim-create.component.html',
  styleUrls: ['./insurance-claim-create.component.scss'],
  standalone: false,
})
export class InsuranceClaimCreateComponent {}
